/**
 * Service to handle toast message
 */
export abstract class ToastMessageFactory {
  /**
   * Post toast message
   *
   * @param body
   */
  abstract postMessage(body: {
    type: string;
    variant?: string;
    title?: string;
    body: string;
    icon?: string;
    styleClass?: string;
    width?: string;
  }): void;
}
